import cardModelTransformer from './cardModelTransformer.service';
import cardGroupModelTransformer from './cardGroupModelTransformer.service';
import cardListModelTransformer from './cardListModelTransformer.service';

angular
    .module('rym.modelTransformer', [])
    .service('cardModelTransformer', cardModelTransformer)
    .service('cardGroupModelTransformer', cardGroupModelTransformer)
    .service('cardListModelTransformer', cardListModelTransformer);
